import { useLogout } from "@/utils/logout";
import { Button } from "@Light/components/page/Button";
import { SupportBottomSheet } from "@Light/components/page/SupportBottomSheet";
import { useScaffold } from "@Light/scaffold";
import clsx from "clsx";
import { useState } from "react";
import { EmptyHeader } from "./EmptyHeader";

export type SessionExpiredProps = {
  title?: string;
};

export const SessionExpired: React.FC<SessionExpiredProps> = ({ title }) => {
  const logout = useLogout("session_expired");
  const scaffold = useScaffold();
  const Title = scaffold.page.title;
  const Subtitle = scaffold.page.subtitle;
  const [supportOpen, setSupportOpen] = useState(false);
  return (
    <div className="flex flex-col h-full">
      <EmptyHeader />
      <div className="flex justify-center items-center text-center h-full px-4">
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-2">
            <Title>{title || "Your session has expired"}</Title>
            <Subtitle>
              <span>
                Something unexpected occurred. Please close and try again. If
                the error persists, please
              </span>{" "}
              <span
                className={clsx(
                  "font-medium cursor-pointer",
                  scaffold.page.colors.text.info,
                )}
                onClick={() => {
                  setSupportOpen(true);
                }}
              >
                contact us
              </span>
              <span>.</span>
            </Subtitle>
          </div>
          <Button
            onClick={() => {
              logout();
            }}
          >
            Close
          </Button>
        </div>
      </div>
      <SupportBottomSheet
        open={supportOpen}
        onClose={() => {
          setSupportOpen(false);
        }}
      />
    </div>
  );
};
